import { render, staticRenderFns } from "./_base-list-filters-department.vue?vue&type=template&id=1d419442&"
import script from "./_base-list-filters-department.vue?vue&type=script&lang=js&"
export * from "./_base-list-filters-department.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports